import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';

@Injectable()
export class PriceListCommandHandlerResolver extends CommandHandlerResolver {
  constructor(deleteHandler: DeleteCommandHandler, editHandler: EditCommandHandler) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
  }
}
